const pageNavigationItem = document.querySelectorAll(".page-navigation-item");
const pageNavigationParent = document.querySelectorAll(".page-navigation-parent");
const subMenuItems = document.querySelectorAll(".page-navigation-sub-menu");
const subMenuItems2 = document.querySelectorAll(".page-navigation-sub-menu li");

// Removes active "open" classes
function removeOpenClasses() {
    subMenuItems.forEach(function(el) {
        el.classList.remove("open");
    });
}

// Removes "active-sub" classes
function removeActiveClasses() {
    pageNavigationParent.forEach(function(el) {
        el.classList.remove("active-sub");
    });
}

// Sub menu
pageNavigationItem.forEach(function(el) {
        el.addEventListener("click", (e) => {
        let subMenu = e.target.closest("div, li").querySelector(".page-navigation-sub-menu");
        let subMenu2 = el.querySelector(".page-navigation-sub-menu--2");
        let subMenu2Anchor = el.querySelector("li.has-children a");

        if (!subMenu.classList.contains("open")) {
            removeOpenClasses();
            removeActiveClasses();
            el.querySelector("a").classList.add("active-sub");
            subMenu.classList.add("open");
        } 
        else {
            subMenu.classList.remove("open");
            el.querySelector("a").classList.remove("active-sub");
            subMenu2.classList.remove("open");
            subMenu2Anchor.classList.remove("active-sub");
        }
    });
});

// Sub menu 2
subMenuItems2.forEach(function(el) {
    el.addEventListener("click", function(e) {
        let subMenu5 = e.target.closest("li").querySelector(".page-navigation-sub-menu--2");
        if (!subMenu5.classList.contains("open")) {
            subMenu5.classList.add("open")
            el.querySelector("a").classList.add("active-sub")
        } else {
            subMenu5.classList.remove("open");
            el.querySelector("a").classList.remove("active-sub")
        }
    })
});